

export const checkText: Object<String> = {
    'DonorBox': 'Open donorbox',
    'RDonorBox': 'Remove donorbox',
    'clicknPledge': 'Open click and pledge',
    'RclicknPledge': 'Remove click and pledge',
    'Recording': 'Open recording',
    'Livestream': 'Open livestream',
    'WhiteBoard': 'Open whiteboard',
    'LivePad': 'Open LivePad',
    'CLivePad': 'Close LivePad',
    'CWhiteBoard': 'Close Whiteboard',
    'ScreenShare': 'Start Screen sharing',
    'StopScreen': 'Stop Screen sharing',
    'Youtube': 'Open YouTube',
    'CYoutube': 'Close YouTube',
    'ParticipantP': 'Open Participant pane',
    'VcDialog': 'open virtual background',
    'ChatBox': 'open chat box',
    'VideoQ': 'open video quality dialog',
    'SpeckerS': 'open speaker stats',
    'Settings': 'Open settings',
    'Fullscreen': 'Open full screen',
    'InviteP': 'Invite People',
    'RaiseHand': 'Raise Hand',
    'LowerHand': 'Lower Hand'

};
